import { Directive } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[validation]'
})
export class MbValidationDirective {

  constructor() { }

}
